import { NAME_APP, modules } from '@/constants';
import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-cycle
import router from '@/router/index';
// eslint-disable-next-line import/no-cycle
import Api from '~utils/Api';
import { setCookie, deleteCookie, getCookie } from '~utils/cookies';
// eslint-disable-next-line import/no-cycle
import { ConstantParams } from '../types';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '../index';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '../auth/authModule';
// import {  } from './types';

export const useRouterStore = defineStore('router', {
  state: () => ({

  }),

  getters: {

  },

  actions: {
    async getAppList(): Promise<any[]> {
      const params = {
        Name_event: 'GET:app_list',
        id_people: useAuthStore().user.id_people ?? 0,
        ...useMainStore().getConstantParams,
      };
      const result = await Api.get(params);
      if (!result.errorType) {
        const { data } = result;
        if (data) {
          return data;
        }
      }
      return [];
    },
  },
});
